<form [formGroup]="adrForm" (ngSubmit)="addAdr()">
  <div class="form-container">
    <div class="left-column">
      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.codeHecate.header'| transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="codeHecate" class="flex-auto" />
        <small class="p-error block">
          <p-message *ngIf="adrForm.controls['codeHecate'].invalid && adrForm.controls['codeHecate'].touched && adrForm.get('codeHecate')?.hasError('required')" severity="danger" text="Le champ pour le numeroUN est requis."></p-message>
          <p-message *ngIf="adrForm.controls['codeHecate'].invalid && adrForm.controls['codeHecate'].touched && adrForm.get('codeHecate')?.hasError('pattern')" severity="danger" text="Le champ doit être un nombre."></p-message>
        </small>
      </div>

      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.numeroUN.header'| transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="numeroUN" class="flex-auto" />
        <small class="p-error block">
          <p-message *ngIf="adrForm.controls['numeroUN'].invalid && adrForm.controls['numeroUN'].touched && adrForm.get('numeroUN')?.hasError('required')" severity="danger" text="Le champ pour le numeroUN est requis."></p-message>
          <p-message *ngIf="adrForm.controls['numeroUN'].invalid && adrForm.controls['numeroUN'].touched && adrForm.get('numeroUN')?.hasError('pattern')" severity="danger" text="Le champ doit être un nombre."></p-message>
        </small>
      </div>

      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.designation.header'| transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="designation" class="flex-auto" />
        <small class="p-error block">
          <p-message *ngIf="adrForm.controls['designation'].invalid && adrForm.controls['designation'].touched" severity="danger" text="Le champ pour la désignation est requis."></p-message>
        </small>
      </div>

      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.classe.header'| transloco }}</label>
        <input pInputText formControlName="classe" class="flex-auto" />
      </div>

      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.codeDanger.header'| transloco }}</label>
        <input pInputText formControlName="codeDanger" class="flex-auto" />
      </div>
    </div>

    <div class="rigth-column">
      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.codeTunnels.header'| transloco }}</label>
        <input pInputText formControlName="codeTunnels" class="flex-auto" />
      </div>

      <div class="form-field">
        <label>{{ 'referentiels.list.adrProperties.groupeEmballage.header'| transloco }}</label>
        <input pInputText formControlName="groupeEmballage" class="flex-auto" />
      </div>
    </div>
  </div>

  <div class="button-container">
    <p-button pRipple label="{{ 'button.cancel' | transloco }}" [rounded]="true" severity="secondary" (onClick)="close(true)" />
    <p-button pRipple label="{{ 'button.validate' | transloco}}" [rounded]="true" type="submit" [disabled]="adrForm.invalid" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
